<template>
  <b-collapse id="simualtion-card" class="evaluation-card simulation-card" animation="slide" data-cy="simulation-data">
    <template #trigger="{ open }">
      <div class="card-header" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          Datos de la simulación
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </div>
    </template>
    <div class="card-block p-0">
      <div class="subcard">
        <b-field label="Tipo de crédito" horizontal>
          <b-select
            v-model="localValue.generalParams.creditType"
            :disabled="readOnly"
            size="is-small"
            placeholder="Selecciona un tipo de crédito"
            expanded>
            <option value="MORTAGE">Hipotecario</option>
          </b-select>
        </b-field>

        <b-field label="Propósito" horizontal>
          <b-select
            v-model="localValue.offerParams.purpose"
            :disabled="readOnly"
            size="is-small"
            placeholder="Selecciona un propósito"
            expanded>
            <option value="HOME">Para vivir</option>
          </b-select>
        </b-field>
        <BInputExpanded
          disabled
          value="0"
          label="Pie"
          placeholder="Ingresa valor en UF"
          prefix="UF"
          size="is-small"
          expanded
          prefix-position="left" />
      </div>

      <div class="subcard is-gray">
        <div class="subcard-header header-switch">
          <b-field label="¿Tiene subsidio?" horizontal>
            <b-switch
              v-model="subsidySwitch"
              :disabled="readOnly"
              size="is-small"
              data-cy="hasSubsidy" />
          </b-field>
        </div>
        <div v-if="subsidySwitch" class="fields-has-text-right">
          <BInputExpanded
            v-model="localValue.offerInputs.downPayment"
            :disabled="readOnly"
            label="Monto Ahorro"
            placeholder="Ingresa ahorro en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />
          <BInputExpanded
            v-model="localValue.offerInputs.subsidy"
            :disabled="readOnly"
            label="Monto subsidio"
            placeholder="Ingresa monto subsidio en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />
        </div>
      </div>

      <div class="subcard">
        <BInputExpanded
          v-model="localValue.offerInputs.numberOfMonths"
          :disabled="readOnly"
          label="Plazo"
          placeholder="0,00"
          prefix="UF"
          size="is-small"
          prefix-position="left" />

        <BInputExpanded
          v-model="localValue.offerInputs.numberOfGraceMonths"
          :disabled="readOnly"
          label="Meses de gracia"
          placeholder="0,00"
          prefix="UF"
          size="is-small"
          prefix-position="left" />

        <b-field label="¿Necesita financiar GOPs?" horizontal>
          <b-switch v-model="getSimulationCard.needGops" size="is-small" :disabled="readOnly" />
        </b-field>

        <b-field label="¿Usa cuotas dobles?" horizontal>
          <b-switch
            v-model="localValue.offerInputs.useDoublePayments"
            size="is-small"
            :disabled="readOnly" />
        </b-field>

        <b-field label="¿Tiene coeudor?" horizontal>
          <b-switch v-model="getSimulationCard.hasCodebtor" size="is-small" :disabled="readOnly" />
        </b-field>

        <b-field label="Fecha desembolso" horizontal expanded>
          <b-select
            v-model="localValue.offerInputs.purchaseDate"
            :disabled="readOnly"
            size="is-small"
            placeholder="Selecciona una fecha"
            expanded>
            <option value="00-03"> Menos de 3 meses</option>
            <option value="03-06"> De 3 a 6 meses</option>
            <option value="06-12"> De 6 meses a 1 año</option>
            <option value="12OrMore"> Más de 1 año</option>
            <option value="notDefined"> No lo se</option>
          </b-select>
        </b-field>
      </div>
    </div>
  </b-collapse>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import BInputExpanded from '@/ui/components/input/BInputExpanded.vue';

export default {
  name: 'SimulationCard',
  components: { BInputExpanded },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subsidySwitch: false,
      localValue: this.simulation
    };
  },
  computed: {
    ...mapState('evaluation', ['simulation']),
    ...mapGetters('evaluation', ['getSimulationCard'])
  },
  watch: {
    localValue: {
      deep: true,
      handler() {
        this.setSimulation(this.localValue);
      }
    }
  },
  created() {
    this.localValue = this.simulation;
    this.subsidySwitch = this.getSimulationCard.hasSubsidy;
  },
  methods: {
    ...mapMutations('evaluation', ['setSimulation'])
  }

};
</script>

<style>
#simualtion-card .subcard .is-horizontal .field-label {
  flex-grow: 3;
}
</style>
